<template>
  <!-- <div class='panel bgPanel mt1x pb1x emptyToken_EE h24x  '>
    <div class="title title-bg" style="margin-bottom:0">
      <span :title="getLanguageStr('计划发电量','计划发电量')">{{getLanguageStr("计划发电量","计划发电量")}}</span>
    </div>
    <div class="cb table">

    </div>
  </div> -->
  <div>
    <PlannedGeneration ref='PlannedGeneration' :chartHeight='"h25x"' :stationId='stationInfo.id'/>
  </div>
</template>
<script>
import { getLanguageStr } from '@/util/language'
import PlannedGeneration from '@/view/maintain/light/plant/detail/PlannedGeneration.vue'
export default {
  name: 'powerplan',
  components: {
    PlannedGeneration
  },
  props: ['stationInfo'],
  data () {
    return {
      stage
    }
  },
  methods: {
    getLanguageStr,
    getGenerationPlanData () {
      this.$refs.PlannedGeneration.getGenerationPlanData()
    }
  },
  mounted () {
    setTimeout(()=>{
     
    },5000)
  }
}
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/PowerPlan.vue